import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./config";
import "./styles/Login.css";

const { Title } = Typography;
const { Option } = Select;

function CreateAccount() {
  const [loading, setLoading] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const countryCodes = [
    { code: "+1", name: "USA" },
    { code: "+44", name: "UK" },
    { code: "+91", name: "India" },
    { code: "+61", name: "Australia" },
    { code: "+81", name: "Japan" },
  ];

  const countries = [
    "India",
    "United States",
    "United Kingdom",
    "Australia",
    "Japan",
    "Canada",
    "Germany",
    "France",
  ];

  // ---------------- Step 1: Send OTP ----------------
  const handleSendOtp = async () => {
  try {
    const { email } = await form.validateFields(["email"]);
    setVerifying(true);

    const res = await fetch(`${BASE_URL}/send_emailotp.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (data.success) {
      message.success("OTP sent to your email!");
      setOtpSent(true);
    } else {
      message.error(data.message || "Failed to send OTP");
    }
  } catch (err) {
    // Validation error (email empty or invalid)
    return;
  } finally {
    setVerifying(false);
  }
};


  // ---------------- Step 2: Verify OTP ----------------
  const handleVerifyOtp = async () => {
    const email = form.getFieldValue("email");

    if (!otp) {
      message.error("Please enter OTP");
      return;
    }

    setVerifying(true);

    try {
      const res = await fetch(`${BASE_URL}/verify_email_otp.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await res.json();

      if (data.success) {
        message.success("Email verified successfully!");
        setEmailVerified(true);
        setOtpSent(false);
      } else {
        message.error(data.message || "Invalid OTP");
      }
    } catch (error) {
      message.error("Something went wrong while verifying OTP");
    }

    setVerifying(false);
  };

  // ---------------- Step 3: Create Account ----------------
  const onFinish = async (values) => {
    if (!emailVerified) {
      message.error("Please verify your email before creating account");
      return;
    }

  if (!values.company_name) delete values.company_name;
  if (!values.company_website) delete values.company_website;

    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/create_account.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      const data = await res.json();

      if (data.success) {
        message.success("Account created successfully!");
        navigate("/");
      } else {
        message.error(data.message);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="top-bar">
        <img src={require("./assets/meet.png")} alt="Logo" className="logo" />
      </div>

      <div className="login-container">
        <div className="card">
          {/* Left Section */}
         <div className="features-section">
                    <Title level={3} className="features-title">
                      Features of Meeting Fix
                    </Title>
        
                    <ul className="features-list">
                      <li>☑ SaaS (software as a service) solution</li>
                      <li>☑ Schedule your appointment & meetings</li>
                      <li>☑ Connect with website and mobile apps</li>
                      <li>☑ Add video Conferencing</li>
                      <li>☑ Customise your booking page</li>
                      <li>☑ Automatically find the best time for your routines</li>
                      <li>☑ Protect personal time for meals and travel</li>
                      <li>☑ Unlimited meetings using Meeting Fix links</li>
                      <li>☑ Integrate with Zoom, Google Meet, Teams, and more</li>
                    </ul>
        
                    <Button className="read-more-btn">
                      <a
                        href="https://meetingfix.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read More..
                      </a>
                    </Button>
        
                    <div className="footer-links">
                      <a
                        href="https://meetingfix.com/contact_us.php"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contact us
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://meetingfix.com/legal/privacy_policy.php"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                      <br />
                      © Foster Digital Technology Pvt Ltd.
                    </div>
                  </div>

          {/* Right Section */}
          <div className="login-section">
            <Title level={2} className="signin-title">
              Create an Account
            </Title>

            <Form layout="vertical" onFinish={onFinish} form={form}>
              <Form.Item
                label="Full Name"
                name="name"
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input placeholder="Enter your full name" />
              </Form.Item>

              {/* Email field + Verify */}
    <Form.Item
  label="Email"
  required
>
  <div style={{ display: "flex", gap: "10px" }}>
    <Form.Item
      name="email"
      noStyle
      rules={[
        { required: true, message: "Please enter your email" },
        { type: "email", message: "Enter a valid email" },
      ]}
    >
      <Input
        placeholder="Enter your email"
        disabled={emailVerified}
      />
    </Form.Item>

    <Button
      htmlType="button"
      onClick={handleSendOtp}
      loading={verifying}
      disabled={emailVerified}
    >
      {emailVerified ? "Verified ✓" : "Verify"}
    </Button>
  </div>

  <div style={{ marginTop: 6, fontSize: 13, color: "#555" }}>
    Please verify your email
  </div>
</Form.Item>





               

              {/* OTP Input */}
              {otpSent && !emailVerified && (
                <Form.Item label="Enter OTP">
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Input
                      placeholder="Enter 4-digit OTP"
                      value={otp}
                      maxLength={4}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                    <Button
                      type="primary"
                      onClick={handleVerifyOtp}
                      loading={verifying}
                    >
                      Verify OTP
                    </Button>
                  </div>
                </Form.Item>
              )}

              {/* Phone */}
              <Form.Item
                label="Contact Number"
                name="phone"
                rules={[
                  { required: true, message: "Please enter your contact number" },
                ]}
              >
                <Input
                  addonBefore={
                    <Form.Item name="country_code" noStyle initialValue="+91">
                      <Select style={{ width: 90 }}>
                        {countryCodes.map((item) => (
                          <Option key={item.code} value={item.code}>
                            {item.code}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  }
                  placeholder="Enter your contact number"
                />
              </Form.Item>

              {/* Country */}
              <Form.Item
                label="Country"
                name="country"
                rules={[
                  { required: true, message: "Please select your country" },
                ]}
              >
                <Select placeholder="Select your country">
                  {countries.map((country) => (
                    <Option key={country} value={country}>
                      {country}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Company Name */}
              <Form.Item
                label="Company Name"
                name="company_name"
              
              >
                <Input placeholder="Enter your company name" />
              </Form.Item>

              {/* Company Website */}
              <Form.Item
                label="Company Website"
                name="company_website"
                
              >
                <Input placeholder="Enter your company website" />
              </Form.Item>

              {/* Password Field */}
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                  { min: 6, message: "Password must be at least 6 characters" },
                ]}
                hasFeedback
              >
                <Input.Password placeholder="Enter your password" />
              </Form.Item>

              {/* Confirm Password */}
              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  { required: true, message: "Please confirm your password" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm your password" />
              </Form.Item>

              {/* Submit */}
              <Form.Item>
                <Button
                  type="secondary"
                  htmlType="submit"
                  block

                  loading={loading}
                  className="signin-btn"
                  disabled={!emailVerified}
                >
                  Create Account
                </Button>
              </Form.Item>

              <div style={{ textAlign: "center" }}>
                <a
                  onClick={() => navigate("/")}
                  style={{ cursor: "pointer", color: "#1890ff" }}
                >
                  Already have an account? Sign In
                </a>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAccount;
